import React from 'react';
import '../styles/Wine.css';
import { useInView } from 'react-intersection-observer';

const texts = {
  title: {
    en: 'Online Shop',
    fr: 'Boutique en ligne'
  }
}

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const ShopCard = (props) => {
  const { ref, inView } = useInView();
  const lang = props.lang || 'en';

  return (
    <div 
        ref={ref} 
        className="col-12 d-flex justify-content-center"
        >
      <div 
        className={`wine-card shop-card-centered ${animate(inView, 'bounceInLeft', 0, 'fast')}`}
        onClick={() => {
          window.open(`https://wine.lacroixdemillorit.com/${lang === 'fr' ? lang : ''}`, '_blank', 'noopener');
        }}
        role="link"
        aria-label={texts.title[lang]}
      >
        <div className="wine-card-img">
          <img src={`/shop.png`} className="img-fluid" alt="shop"/>
        </div>
        <div className="wine-card-info text-center">
          <h4>{texts.title[lang]}</h4>
        </div>
      </div>
    </div>
  )
}

export default ShopCard;
